import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import Viewer from 'v-viewer'
import VueCropper from 'vue-cropper'
import basiCcontainer from '@/layouts/app/components/basiCcontainer'
import '@/libs/wf-components-ui/index.scss'
import 'viewerjs/dist/viewer.css'
import VueCoreVideoPlayer from 'vue-core-video-player'
import 'tippy.js/dist/tippy.css'; // optional for styling
import {
  parseTime
} from '@/utils/utils'
import '@/libs';
import '@/assets/scss/global.scss';
import 'babel-polyfill'
import '@/utils/ldf-img.js';
import directive from './permissions.js'
import TaskPanel from "@/views/task/taskPanel"
import VueBarcode from '@chenfengyuan/vue-barcode';
import commonTable from '@/components/commonTable'
import Myavatar from '@/components/avatar'
import mixin from './mixin'
import FollowTask from '@/components/followTask'
import toolTip from '@/components/toolTip'
import nothing from '@/components/nothing'
import videoPlaye from '@/components/videoPlaye/index.js'
Vue.component(VueBarcode.name, VueBarcode);
Vue.config.productionTip = false;
Vue.prototype.parseTime = parseTime
Vue.use(directive)
Vue.component('commonTable', commonTable)
Vue.component('nothing', nothing)
Vue.component('basiCcontainer', basiCcontainer)
Vue.component('Myavatar', Myavatar)
Vue.component('TaskPanel', TaskPanel)
Vue.component('FollowTask', FollowTask)
Vue.component('toolTip', toolTip)
Vue.use(VueCoreVideoPlayer)
Vue.use(VueCropper)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  }
})
Vue.use(videoPlaye)
Vue.mixin(mixin)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
